import { Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { StaffListItem } from '../../../interfaces/staff/staff-list-item.interface'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { RouterModule } from '@angular/router'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { CardComponent } from '../../card/card.component'
import { CardFooterDirective } from 'src/app/shared/directives/card/card-footer.directive'
import { PhoneNumberPipe } from 'src/app/shared/pipes/phone-number.pipe'
import { DatePipe } from '@angular/common'
import { SendStaffPushNotificationModalComponent } from 'src/app/secure/components/send-staff-push-notification-modal/send-staff-push-notification-modal.component'

@Component({
    selector: 'sf-staff-detail',
    imports: [
        FontAwesomeModule,
        RouterModule,
        NgbTooltipModule,
        CardComponent,
        CardFooterDirective,
        ButtonComponent,
        PhoneNumberPipe,
        DatePipe,
    ],
    templateUrl: './staff-detail.component.html',
    styleUrls: ['./staff-detail.component.scss'],
})
export class StaffDetailComponent {
    @Input({ required: true }) staff!: StaffListItem

    @Output() sendPushNotificationOpened = new EventEmitter<void>()

    #ngbModal = inject(NgbModal)

    openSendPushNotificationModal() {
        const ref = this.#ngbModal.open(SendStaffPushNotificationModalComponent, {
            centered: true,
            size: 'lg',
            backdrop: 'static',
        })
        ref.componentInstance.userIds = this.staff.id

        this.sendPushNotificationOpened.emit()
    }
}
